import { useNavigate } from "react-router-dom"
import "./capabilities.component.css"
import { useState } from "react"
import { daggerNavigate } from "../../utils/navigate.util"

const CapabilitiesComponent = (props) => {
  const { Heading, CtaLabel, CtaPageLink, Capability, DisableExpand } = props

  const [expanded, setExpanded] = useState({})
  const navigate = useNavigate()
  const handleCtaClick = () => {
    daggerNavigate(() => navigate(`/${CtaPageLink.data.attributes.Slug}`))
  }

  const handleToggleItem = (itemId) => {
    if (DisableExpand) {
      return
    }

    const updated = { ...expanded }
    if (updated[itemId]) {
      delete updated[itemId]
    } else {
      updated[itemId] = true
    }

    setExpanded(updated)
  }

  return (
    <div className="dagger-capabilities">
      {Heading && <h1>{Heading}</h1>}
      {Capability &&
        Capability.length > 0 &&
        Capability.map((c) => {
          return (
            <div className="capability" key={c.id}>
              <div
                className={`capability-heading ${DisableExpand ? "disabled" : ""}`}
                onClick={() => handleToggleItem(c.id)}
              >
                <h3>{c.Heading}</h3>
                {!DisableExpand && (
                  <button
                    className={
                      expanded[c.id]
                        ? "capability-toggle-btn expanded"
                        : "capability-toggle-btn"
                    }
                  >
                    <span className="next-btn" />
                  </button>
                )}
              </div>
              {expanded[c.id] && (
                <div className="capability-copy">{c.Description}</div>
              )}
            </div>
          )
        })}
      {CtaLabel && CtaPageLink && (
        <button className="dagger-outline-btn" onClick={handleCtaClick}>
          {CtaLabel}
        </button>
      )}
    </div>
  )
}

export default CapabilitiesComponent
